import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import countries from "../../utils/countries";

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent implements OnInit, AfterViewInit {
  public form: FormGroup;
  public loading = false;
  public errorMessage?: string;
  public attemptedSubmit = false;
  public successfullySent = false;
  public captchaVisibleAnimation = false;
  public countries = countries;

  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      passwordConfirm: new FormControl('', [Validators.required]),
      company: new FormControl('', [Validators.required]),
      telephone: new FormControl('', [Validators.required]),
      country: new FormControl('', [Validators.required]),
      token: new FormControl('', [Validators.required])
    });
  }

  ngAfterViewInit() {
    setTimeout(() => this.captchaVisibleAnimation = true, 100);
  }

  get firstName(): FormControl { return this.form.get('firstName') as FormControl; }
  get lastName(): FormControl { return this.form.get('lastName') as FormControl; }
  get email(): FormControl { return this.form.get('email') as FormControl; }
  get password(): FormControl { return this.form.get('password') as FormControl; }
  get passwordConfirm(): FormControl { return this.form.get('passwordConfirm') as FormControl; }
  get company(): FormControl { return this.form.get('company') as FormControl; }
  get country(): FormControl { return this.form.get('country') as FormControl; }
  get telephone(): FormControl { return this.form.get('telephone') as FormControl; }
  get token(): FormControl { return this.form.get('token') as FormControl; }

  onCaptchaResolved(captchaResponse: string) {
    this.token.setValue(captchaResponse);
    this.token.setErrors(captchaResponse ? null : {required: true});
  }

  async onRegisterClick() {
    this.errorMessage = '';
    this.attemptedSubmit = true;
    if (this.form.invalid) {
      if (!this.form.dirty) {
        this.form.markAsDirty();
      }
      return;
    }
    const firstName = this.firstName.value.trim();
    const lastName = this.lastName.value.trim();
    const email = this.email.value.trim();
    const password = this.password.value.trim();
    const passwordConfirm = this.passwordConfirm.value.trim();
    const company = this.company.value.trim();
    const countryCode = this.country.value.toString().trim();
    const countryPrefix = this.getPrefixFromCountryCode(countryCode);
    if (typeof countryPrefix !== "string") {
      return;
    }
    const country = this.getCountryNameFromCountryCode(countryCode);
    if (typeof country !== "string") {
      return;
    }
    const telephone = countryPrefix + this.telephone.value.toString().trim();
    const token = this.token.value;
    this.loading = true;
    try {
      const response = await this.userService.register(
        firstName,
        lastName,
        email,
        password,
        passwordConfirm,
        company,
        telephone,
        country,
        token
      );
      if (response === true) {
        this.successfullySent = true;
        setTimeout(this.redirectToLogin.bind(this), 3000);
      } else {
        console.log(response);
        throw new Error("Unknown server response");
      }
    } catch(err) {
      if (typeof err.message !== "string" || !err.message) {
        console.error(err);
      }
      this.loading = false;
      this.attemptedSubmit = false; // Supress form validation errors
      this.errorMessage = ((err && err.message ? err.message : err) || "Unknown error").toString();
    }
    this.loading = false;
  }

  getCountryNameFromCountryCode(countryCode: any) {
    if (!countryCode || isNaN(parseInt(countryCode))) {
      this.errorMessage = "Country code must be numeric";
      return;
    }
    const countryId = parseInt(countryCode, 10);
    if (!countryId || !this.countries[countryId]) {
      return "";
    }
    return this.countries[countryId].name;
  }

  getPrefixFromCountryCode(countryCode: string) {
    if (!countryCode || isNaN(parseInt(countryCode))) {
      this.errorMessage = "Country code must be numeric";
      return;
    }
    const countryId = parseInt(countryCode, 10);
    if (!countryId || !this.countries[countryId]) {
      return "000";
    }
    return this.countries[countryId].codeNumber.replace("+", "").trim() || "000";
  }

  redirectToLogin() {
    console.log('Redirecting to login');
    this.router.navigate(['/login']);
  }

}
